import Vue from 'vue';
import { Collapse } from 'bootstrap';

export default {
  init() {},
  finalize() {
    /*
    var cookieAlert = document.querySelector('.cookiealert');
    var acceptCookies = document.querySelector('.acceptcookies');
    var rejectCookies = document.querySelector('.rejectcookies');

    if (!getCookie('acceptCookies') && !getCookie('rejectCookies')) {
      cookieAlert.classList.add('show');
    } else if (getCookie('acceptCookies')) {
      setupGa();
    }

    acceptCookies.addEventListener('click', function() {
      setCookie('acceptCookies', true, 365);
      cookieAlert.classList.remove('show');
      setupGa();
    });

    rejectCookies.addEventListener('click', function() {
      setCookie('rejectCookies', true, 365);
      cookieAlert.classList.remove('show');
    });
   */

    function setupGa() {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', 'UA-154736013-2');
    }

    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = 'expires=' + d.toUTCString();
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    function getCookie(cname) {
      var name = cname + '=';
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    }

    document
    .querySelector('.hamburger-toggle')
    .addEventListener('click', function() {
      document.querySelector('.mobile-overlay-menu').classList.toggle('open');
    });


    const navbarApp = new Vue({
      el: '.navbar-app',
      data: {
        currentItem: null,
        offsetLeft: 0,
      },
      methods: {
        setCurrentItem(i, e) {
          this.offsetLeft = e.target.offsetLeft;
          if (this.currentItem == i) {
            this.currentItem = null;
          } else {
            this.currentItem = i;
          }
        },
      },
      mounted() {
        var myLazyLoad = new window.LazyLoad();
        myLazyLoad.update();
        var self = this;
        document.addEventListener('click', function(e) {
          if (e.target.closest('.navbar-app') == null) {
            self.currentItem = null;
          }
        });
      },
    });
    navbarApp;
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js